// extracted by mini-css-extract-plugin
export default {"social-link":"SocialLink_social-link__gBjA0","icon":"SocialLink_icon__pO-Pv"};